import {combineReducers} from 'redux';
import ListOrder from './ListOrder/reducer';


export default combineReducers({
    ListOrder,
});